import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { packItems, TOTAL_VALUE } from '../data/content';
export function PackSection() {
  return <Section eyebrow="Sección 5" title="El pack de protección completo" tone="darker" data-id="element-83" data-mp="2jdibd5sebi0u">
      <p className="-mt-3 mb-7 text-base text-slate-400" data-id="element-84" data-mp="2fc6r7fsajp01">
        Al adquirir Escudo Digital 2025 hoy, te llevás:
      </p>

      <ul className="divide-y divide-ink-700 overflow-hidden rounded-2xl border border-ink-700 bg-ink-800" data-id="element-85" data-mp="2addc5ixcvpxr">
        {packItems.map(item => {
        const Icon = item.icon === 'guide' ? BookOpenIcon : GiftIcon;
        const isGuide = item.icon === 'guide';
        return <li key={item.title} className="flex items-start gap-4 p-5" data-id="element-86" data-mp="1vo7fo2pwkdtk">
              <span className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${isGuide ? 'bg-shield-500/15 text-shield-500' : 'bg-safe-500/15 text-safe-500'}`} data-id="element-87" data-mp="1vq0mbi0imy1k">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-88" data-mp="1mo178v92a419" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-89" data-mp="2d34b2qk93qnv">
                <h3 className="font-display text-base font-bold text-white" data-id="element-90" data-mp="2d2cfhfqnlsxl">{item.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-400" data-id="element-91" data-mp="2hwqfxwk6aq94">{item.description}</p>
              </div>
              <span className="shrink-0 whitespace-nowrap text-sm font-semibold text-slate-500 line-through" data-id="element-92" data-mp="2852k7jgl2n1u">
                {item.value}
              </span>
            </li>;
      })}
        <li className="flex items-center justify-between bg-ink-700/50 px-5 py-4" data-id="element-93" data-mp="2vsu5vdo0kcfs">
          <span className="font-display text-sm font-bold uppercase tracking-wider text-slate-300" data-id="element-94" data-mp="30symd3ox9760">
            Valor total
          </span>
          <span className="font-display text-lg font-extrabold text-white line-through decoration-alert-500 decoration-2" data-id="element-95" data-mp="2rstjn6uoawy6">
            {TOTAL_VALUE}
          </span>
        </li>
      </ul>
    </Section>;
}